//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

export enum IAMProviderType {
  Ldap = "ldap",
}
